// removed export const Shadows = StyleSheet.create({}) because web targets using react-native-web don't render
// styles created using "spread objects" generated by StyleSheet.create({})
import {StyleSheet} from 'react-native';

export const Shadows = StyleSheet.create({
  default: {
    shadowColor: 'rgba(10, 10, 71, 0.1)',
    shadowOffset: {width: 0, height: 2.5},
    shadowOpacity: 0.7,
    shadowRadius: 4,
    elevation: 4,
  },
  small: {
    shadowColor: 'rgba(10, 10, 71, 0.1)',
    shadowOffset: {width: 0, height: 5},
    shadowOpacity: 1,
    shadowRadius: 15,
    elevation: 15,
  },
  regular: {
    shadowColor: 'rgba(10, 10, 71, 0.1)',
    shadowOffset: {width: 0, height: 10},
    shadowOpacity: 0.2,
    shadowRadius: 10,
    elevation: 10,
  },
});
